import RequestService from '@/business/modules/request/request.service';
import type { BookingSuggestionRequest, JoinWaitlistPayload, getTimeOfBusinessParams, inquiryPaymentParmas } from '@/business/modules/request/request.model';

class RequestController {
	static #instance: RequestController;
	private readonly service;

	private constructor() {
		this.service = RequestService.getInstance();
	}

	public static getInstance(): RequestController {
		if (!RequestController.#instance) {
			RequestController.#instance = new RequestController();
		}
		return RequestController.#instance;
	}

	/* user */
	getPendReserveTimeUser(page: number) {
		return this.service.getPendReserveTimeUser(page);
	}

	getCanceledReserveTimeUser(page: number) {
		return this.service.getCanceledReserveTimeUser(page);
	}

	getDoneReserveTimeUser(page: number) {
		return this.service.getDoneReserveTimeUser(page);
	}

	getFutureReserveTimeUser(page: number) {
		return this.service.getFutureReserveTimeUser(page);
	}
	/* user */

	/* business */
	getPendReserveInBusinessBook(page: number) {
		return this.service.getPendReserveInBusinessBook(page);
	}

	getPendReservePreviewInBusinessBook() {
		return this.service.getPendReservePreviewInBusinessBook();
	}

	getFutureReserveInBusinessBook(page: number) {
		return this.service.getFutureReserveInBusinessBook(page);
	}

	getDoneReserveInBusinessBook(page: number) {
		return this.service.getDoneReserveInBusinessBook(page);
	}
	/* business */

	acceptReserveTime(id: string) {
		return this.service.acceptReserveTime(id);
	}

	rejectReserveTime(id: string) {
		return this.service.rejectReserveTime(id);
	}

	markNoShow(id: string) {
		return this.service.markNoShow(id);
	}

	cancelReserve(id: string) {
		return this.service.cancelReserve(id);
	}

	getBookingSuggestions(data: BookingSuggestionRequest) {
		return this.service.getBookingSuggestions(data);
	}

	getWaitlistOffer(token: string) {
		return this.service.getWaitlistOffer(token);
	}

	joinWaitlist(data: JoinWaitlistPayload) {
		return this.service.joinWaitlist(data);
	}

	redirectToPayment(data: object) {
		return this.service.redirectToPayment(data);
	}

	reserveWithoutPayment(data: object) {
		return this.service.reserveWithoutPayment(data);
	}

	payWithWallet(data: object) {
		return this.service.payWithWallet(data);
	}

	inquiryPayment(data: inquiryPaymentParmas) {
		return this.service.inquiryPayment(data);
	}

	getRequestDetail(requestId: string, source: 'receive' | 'send' = 'receive') {
		return this.service.getRequestDetail(requestId, source);
	}

	getTimeOfBusiness(data: getTimeOfBusinessParams) {
		return this.service.getTimeOfBusiness(data);
	}
}

export default RequestController;
